/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
const React = require('react');

const { useState } = React;
const Chevron = require('./Chevron');

const GenericCollapse = ({ title, children, startOpened = false, showHeader = true, i18n }) => {
  const [showContent, setShowContent] = useState(startOpened);

  return (
    <div className="live-demo-collapse--item-container" key={title} id={title}>
      {showHeader && (
        <div
          alt={showContent ? i18n.gettext('Cerca') : i18n.gettext('Expandir')}
          className="live-demo-collapse-item--header"
          onClick={() => { setShowContent(!showContent); }}
        >
          <span className="live-demo-collapse-item--title">{title}</span>
          <Chevron className={`collapse-item--chevron${showContent ? '__opened' : ''}`} />
        </div>
      )}
      {!showHeader && (
        <span className="live-demo-collapse-item--title">{title}</span>
      )}
      <span className={`live-demo-collapse-item--content ${showContent ? 'live-demo-collapse-item--content__opened' : ''}`}>
        {children}
      </span>
    </div>);
};

module.exports = GenericCollapse;
